(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  const privacyPath = `${window.Shopify?.routes?.root || '/'}policies/privacy-policy`;
  const privacyUrl = new URL(privacyPath, window.location.origin).href;

  document.querySelectorAll('.footer__klaviyo-band').forEach((band) => {
    const updatePrivacyLinks = () => {
      band.querySelectorAll('a[href]').forEach((link) => {
        if (new URL(link.href).pathname.endsWith('/policies/privacy-policy') && link.href !== privacyUrl) {
          link.href = privacyUrl;
        }
      });
    };

    updatePrivacyLinks();
    new MutationObserver(updatePrivacyLinks).observe(band, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();
})();
